import { Box, Card, CardContent, Typography, Grid, Autocomplete, TextField, Button, Checkbox, Switch } from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import { updateNRCAccess } from "redux/actions/addEditWorker";

const NRCOrderManagement = ({handleChange}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const user = useSelector((state) => state.user.auth.user);
  const nrcData = useSelector(state => state.addEditWorker.workerRoles.NRC || {});
  console.log("NRCdata", nrcData)
  const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
  const imtRole = useSelector((state) => state.user.imtRole || null);
  const [formValues, setFormValues] = useState({});
  const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
  const [disableSave, setDisableSave] = useState(true);
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
    console.log("IMTime Role", imtRole)
    if(imtRole?.userRole?.role){
        if(imtRole?.userRole?.role === "Support"){
          setReadOnly(true);
        }
        else{
          setReadOnly(false)
        }
      }
  },[imtRole])

  useEffect(() => {
    if(nrcData && Object.keys(nrcData).length>0){
      console.log("nrcData", nrcData);
      const data = _.cloneDeep(nrcData || {});
      setFormValues(data);
    }
  }, [nrcData]);

  useEffect(() => {
    console.log("nrcData formValues", formValues);
    validForm(formValues);
  } ,[formValues])

  const validForm = (formValues) => {
    const isValid = !_.isEqual(formValues, nrcData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        setSnackControl({
          open: true,
          message: "Invalid data to submit. Please check!",
          severity: "info"
        })
      }

      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        activityFamilyId: 'NRC',
        isActive: formValues?.isActive ? true : false
      }
      console.log("NRC submit", formValues, data);
      const response = await dispatch(updateNRCAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "NRC Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "NRC Access update failed.",
          severity: 'error'
        })
      }

    }catch(error){
      console.log("NRC handleSubmit error", error);
      setSnackControl({
        open: true,
        message: "NRC Access failed to submit.",
        severity: "error"
      })
    }
  }


  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
          
          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)'}}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                NRC Order Management
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container rowSpacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    marginBottom={2}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                        inputProps={{ 'aria-label': 'Enable NRC Role switch' }}
                        checked={formValues.isActive}
                        onChange={(e) => {
                          let checked = e.target.checked;
                          setFormValues({ ...formValues, isActive: checked });
                        }}
                        disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={5}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                      onClick={(e) => handleChange(e, 0)}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 30, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled={disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default NRCOrderManagement;
          